import { Text, View } from '@react-pdf/renderer';
import { monthDayYear } from '@ui/util';
import { addDays } from 'date-fns';

import { usePDFContext } from '../../../PDFProvider';
import { getTermText } from '../../utils/get-term-text';
import { styles } from '../styles';
import { SalesRep } from './SalesRep';

type QuoteInformationProps = {
  showFOB?: boolean;
};

export function QuoteInformation({ showFOB = false }: QuoteInformationProps) {
  const { customer, daysUntilExpiration } = usePDFContext();
  const { id, termsNetDays } = customer;

  return (
    <View style={styles.section}>
      {customer.id ? (
        <View style={styles.sectionRow}>
          <Text style={[styles.bold]}>Customer ID #</Text>
          <Text style={[styles.bold]}>{customer.id}</Text>
        </View>
      ) : null}

      <View style={styles.sectionRow}>
        <Text>Inquiry Date</Text>
        <Text>{monthDayYear(new Date().toISOString())}</Text>
      </View>

      <View style={styles.sectionRow}>
        <Text>Expires</Text>
        <Text>
          {monthDayYear(
            addDays(new Date(), Number(daysUntilExpiration)).toISOString(),
          )}
        </Text>
      </View>

      {customer.customerQuoteId ? (
        <View style={styles.sectionRow}>
          <Text>Reference</Text>
          <Text>{customer.customerQuoteId}</Text>
        </View>
      ) : null}

      <View style={styles.sectionRow}>
        <Text>Terms</Text>
        <Text>{getTermText(id, termsNetDays)}</Text>
      </View>

      <SalesRep />

      {showFOB ? (
        <View style={styles.sectionRow}>
          <Text>FOB</Text>
          <Text>Origin</Text>
        </View>
      ) : null}
    </View>
  );
}
